/** Önem derecesi token + border sınıfları (Acil / Yüksek vurgusu). */

export function getOnemToken(value = '') {
  const normalized = String(value).toLowerCase().trim();
  if (['acil', 'urgent'].includes(normalized)) return 'acil';
  if (['yuksek', 'yüksek', 'high'].includes(normalized)) return 'yuksek';
  if (['orta', 'medium'].includes(normalized)) return 'orta';
  if (['dusuk', 'düşük', 'low'].includes(normalized)) return 'dusuk';
  return 'default';
}

/** Kart / panel wrapper için tam çerçeve sınıfı. */
export function getOnemBorderClass(onemDerecesi) {
  const token = getOnemToken(onemDerecesi);
  if (token === 'acil') return 'onem-border-acil';
  if (token === 'yuksek') return 'onem-border-yuksek';
  return '';
}

/** Tablo satırı için sol şerit sınıfı. */
export function getOnemRowClass(onemDerecesi) {
  const token = getOnemToken(onemDerecesi);
  if (token === 'acil') return 'onem-row-acil';
  if (token === 'yuksek') return 'onem-row-yuksek';
  return '';
}

/** Mevcut priority-badge sınıfı ile uyumlu token. */
export function getPriorityToken(value = '') {
  return getOnemToken(value);
}
